export const skills = {
  aboutme: [
    'Python',
    'SQL',
    'JavaScript',
    'CSS',
  ],
  languages: [
    'Python',
    'Java',
    'SQL',
    'JavaScript',
    'Swift',
    'C++'
  ],
  frameworks: [
    'React',
    'SwiftUI',
    'GraphQL',
    'REST APIs'
  ],
  tools: [
    'Git/GitHub',
    'Azure Data Factory (ADF)',
    'Power BI',
    'Snowflake'
  ],
  technologies: [
    'NumPy',
    'pandas',
    'dimod',
    'Streamlit'
  ],
  MachineLearning: [
    'PyTorch',
    'TensorFlow',
    'Scikit-learn',
    'LLMs',
    'RAG',
    'RNNs',
    'IRT',
    'NLP',
    'Unsupervised Learning',
    'Model Optimization'
  ]
};
